/**
 * Per-profile filters for routing modes (Simulação, Operacional, Prévia).
 * Superadmin bypasses. Each mode requires its granular permission
 * (routePlanningSimulation, routePlanningOperational, routePlanningPreview).
 * Screen access (menu/route) is separate: nome_tela Roteirizacao.
 */

export const ROUTING_MODE_PERMISSION_KEYS = {
  1: 'database.permissions.routePlanningSimulation',
  2: 'database.permissions.routePlanningOperational',
  3: 'database.permissions.routePlanningPreview',
};

export function isSuperadminUser(user) {
  if (!user) {
    return false;
  }
  if (Number(user.is_superadmin) === 1 || user.is_superadmin === true) {
    return true;
  }
  if (Number(user.id_perfil_usuario) === 4) {
    return true;
  }
  return String(user.perfil_usuario || '').toLowerCase() === 'superadmin';
}

function hasPermissionKey(userPermissoes, translationKey) {
  if (!translationKey || !Array.isArray(userPermissoes)) {
    return false;
  }
  return userPermissoes.some((p) => p && p.translation_key === translationKey);
}

export function canAccessRoutingMode(user, userPermissoes, modeId) {
  if (!user) {
    return false;
  }
  if (isSuperadminUser(user)) {
    return true;
  }
  const id = Number(modeId);
  const key = ROUTING_MODE_PERMISSION_KEYS[id];
  if (!key) {
    return false;
  }
  return hasPermissionKey(userPermissoes, key);
}

export function filterRoutingModesByPerfil(user, userPermissoes, modes) {
  const list = Array.isArray(modes) ? modes : [];
  if (!user) {
    return [];
  }
  if (isSuperadminUser(user)) {
    return list;
  }
  return list.filter((m) => canAccessRoutingMode(user, userPermissoes, m.id_modo_roteirizacao));
}

export function resolveDefaultRoutingMode(user, userPermissoes, modes) {
  const allowed = filterRoutingModesByPerfil(user, userPermissoes, modes);
  if (!allowed.length) {
    return null;
  }
  return allowed[0].id_modo_roteirizacao;
}

export function hasAnyRoutingModePermission(user, userPermissoes, modes) {
  if (isSuperadminUser(user)) {
    return true;
  }
  return filterRoutingModesByPerfil(user, userPermissoes, modes).length > 0;
}
